(function () {
    'use strict';

    function wizardSearchConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/wizardSearchConfiguration.html',
            link: function (scope) {
            }
        };
    }

    wizardSearchConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('wizardSearchConfiguration', wizardSearchConfiguration);
})();

